<template >

  <v-card color="#3b3e45" elevation="0" style="border-radius: 0px;">
    <v-card-title class="text-h5">
      Comp Profiles
    </v-card-title>
    <v-card-text class="pt-1 px-6">
      You can save your current Composition into a profile and load it later. The profiles are saved, so that other
      managers of this server can use them as well.
    </v-card-text>
    <v-card-actions class="pa-0 pl-3 pr-1 pb-3">
      <v-col class="mx-n1">
        <v-card color="#2f3136" class="mt-n3" elevation="0">
          <v-card-title class="mx-1">
            Save Profile
          </v-card-title>
          <v-row>
            <v-col class="">
              <v-text-field class="px-5" v-model="profileName" outlined dense placeholder="Enter a profile name."
                background-color="secondary" flat>
              </v-text-field>
            </v-col>

          </v-row>
          <v-btn elevation="0" class="mb-5 mx-5 green" :disabled="profileNameIsEntered() === false" color="green"
            @click="saveProfile()">Save</v-btn>
        </v-card>


        <v-hover>
          <template v-slot:default="{ hover }">

            <v-card color="#2f3136" class="mt-5" elevation="0">

              <v-card-title class="mx-1">
                Load Profile
              </v-card-title>
              <v-row>
                <v-col>
                  <v-select :disabled="$store.state.chosenDiscord.premium === false" class="px-5" dense item-color="white" outlined v-model="selectedProfile"
                    :items="loadedProfiles" placeholder="Select a profile." background-color="secondary" flat
                     @change="checkIfDefault();" @click="getProfiles();" return-object >
                    <template v-slot:selection="{ item }">
                      {{ item.profileName }}
                    </template>
                    <template v-slot:item="{ item }">
                      {{ item.profileName }}
                    </template>
                  </v-select>
                </v-col>
                
              </v-row>
              <v-btn elevation="0" class="mb-5 mx-5" :disabled="selectedProfile === '' || $store.state.chosenDiscord.premium === false" @click="applyProfile()"
                color="green">Load</v-btn>

              <v-tooltip bottom
                :disabled="$store.state.permissionLevel === 'admin' || $store.state.permissionLevel === 'manager'">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="d-inline-block">
                    <v-btn elevation="0" class="mb-5" text color="red"
                      :disabled="($store.state.permissionLevel !== 'admin' && $store.state.permissionLevel !== 'manager') || $store.state.chosenDiscord.premium === false"
                      v-if="selectedProfile !== ''" @click="deleteProfile()" :ripple="false">Delete</v-btn>

              
                  </div>
                </template>
                <span>Requires manager role or higher.</span>
              </v-tooltip>

              <v-fade-transition>
                <v-overlay :z-index="0" v-if="hover && $store.state.chosenDiscord.premium === false" absolute
                  opacity="0.8" color="primary">
                  <v-btn elevation="0" x-large color="purple" @click="$router.push('/premium/', () => { })"> <span>
                      <v-icon color="yellow" class="pb-1">mdi-crown-outline</v-icon> Get Premium!
                    </span></v-btn>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </template>
        </v-hover>

      </v-col>

      
    </v-card-actions>
    <v-snackbar color="green" elevation="0" v-model="snackbar1" timeout="4000"><span style="font-size:15px;">Profile
        saved!</span></v-snackbar>
    <v-snackbar color="red" elevation="0" v-model="snackbar2" timeout="4000"><span style="font-size:15px;">Profile
        deleted!</span></v-snackbar>
  </v-card>


</template>
<script>
import axios from "axios";

export default {
  props: {
    closeOverlay: {
      type: Boolean,
    },
  },
  data() {
    return {
      test: [1,2,3,4,5],
      testtest: 2,
      defaultProfileCheck: false,
      snackbar1: false,
      snackbar2: false,
      dialog: false,
      profileName: "",
      selectedProfile: "",
      savedProfiles: [],
      loadedProfiles: [],
      profileSnapshot: {
        server: "",
        profileName: "",
        hash: "",
        accessToken: "",
        title: "",
        permissionLevel: "",
        visibilityLevel: "",
        templateId: "",
        importedEventId: "",
        partyPerRaid: "",
        slotPerParty: "",
        raidDrop: "",
        raidDropBench: "",
        partyNames: "",
        last_updated: "",
        divideArray: "",
        displayRoles: "",
        displayClasses: "",
        overlayDropColorObject: "",
      },
    };
  },
  watch: {
    dialog: function (newValue) {
      if (newValue === false) {
        this.selectedProfile = "";
        this.profileName = "";
      }
    },
  },
  methods: {
    testt(){
    },

    checkIfDefault(){
      let test = localStorage.getItem('defaultProfile')
      if (this.selectedProfile.profileName == test) {
        this.defaultProfileCheck = true
      } else {
        this.defaultProfileCheck = false
      }
    },

    saveDefault(on){
       if (on) {
        localStorage.setItem('defaultProfile', this.selectedProfile.profileName)
       } else {
        localStorage.removeItem('defaultProfile')
       }
    },

    isMobile() {
      return window.innerWidth < 800;
    },

    profileNameIsEntered() {
      if (this.profileName.length > 0) {
        return true;
      } else {
        return false;
      }
    },

    applyProfile() {
      if (this.$store.state.chosenDiscord.premium === true) {
        this.$emit('closeOverlay', false);
        this.$store.state.raidplan.hash= this.$store.state.raidplan.hash
			  this.$store.state.raidplan.title= this.selectedProfile.title
			  this.$store.state.raidplan.permissionLevel= this.selectedProfile.permissionLevel
			  this.$store.state.permissionLevel= this.selectedProfile.permissionLevel
			  this.$store.state.raidplan.visibilityLevel= this.selectedProfile.visibilityLevel
			  this.$store.state.raidplan.importedEventId= this.selectedProfile.importedEventId
			  this.$store.state.raidplan.partyPerRaid= this.selectedProfile.partyPerRaid
			  this.$store.state.raidplan.slotPerParty= this.selectedProfile.slotPerParty
			  this.$store.state.raidplan.raidDrop= this.selectedProfile.raidDrop
			  this.$store.state.raidplan.raidDropBench= this.selectedProfile.raidDropBench
			  this.$store.state.raidplan.partyNames= this.selectedProfile.partyNames
			  this.$store.state.raidplan.last_updated= this.selectedProfile.timestamp
			  this.$store.state.raidplan.divideArray= this.selectedProfile.divideArray
        this.$store.state.raidplan.displayRoles = this.selectedProfile.displayRoles
        this.$store.state.raidplan.displayClasses = this.selectedProfile.displayClasses
        this.$store.state.raidplan.overlayDropColorObject = this.selectedProfile.overlayDropColorObject
        this.$root.$refs.Raidplan.copyRaidplanFromStore();
        this.dialog = false;
        this.$root.$refs.Raidplan.createlogAction("loadedRaidplan",this.selectedProfile)
      }
    },

    deleteProfile() {
      if (this.$store.state.chosenDiscord.premium === true) {
        if (localStorage.getItem('defaultProfile') == this.selectedProfile.profileName) {
          localStorage.removeItem('defaultProfile')
        }
        let server = this.$store.state.chosenDiscord.id;
        let profileName = this.selectedProfile.profileName;

        this.$root.$refs.Raidplan.createlogAction("deletedRaidplan",this.selectedProfile)

        axios
          .post(this.$store.state.url + "/api/profilesRaidplan/delete/", { server, profileName })
          .then((res) => { })
          .catch((error) => {
            console.log("Something went wrong!");
          })
          .finally(() => {
            this.snackbar2 = true;
            this.selectedProfile = ''
          });
      }
    },
    saveProfile() {
      
      this.profileSnapshot.hash = this.$store.state.raidplan.hash
			this.profileSnapshot.accessToken = this.$store.state.raidplan.accessToken
			this.profileSnapshot.title = this.$store.state.raidplan.title
			this.profileSnapshot.permissionLevel = this.$store.state.raidplan.permissionLevel
			this.profileSnapshot.visibilityLevel = this.$store.state.raidplan.visibilityLevel
			this.profileSnapshot.templateId = this.$store.state.raidplan.templateId
			this.profileSnapshot.importedEventId = this.$store.state.raidplan.importedEventId
			this.profileSnapshot.partyPerRaid = this.$store.state.raidplan.partyPerRaid
			this.profileSnapshot.slotPerParty = this.$store.state.raidplan.slotPerParty
			this.profileSnapshot.raidDrop = this.$store.state.raidplan.raidDrop
      this.profileSnapshot.raidDropBench = this.$store.state.raidplan.raidDropBench
			this.profileSnapshot.partyNames = this.$store.state.raidplan.partyNames
			this.profileSnapshot.last_updated = this.$store.state.raidplan.last_updated
			this.profileSnapshot.divideArray = this.$store.state.raidplan.divideArray
      this.profileSnapshot.displayRoles = this.$store.state.raidplan.displayRoles
      this.profileSnapshot.displayClasses = this.$store.state.raidplan.displayClasses
      this.profileSnapshot.overlayDropColorObject = this.$store.state.raidplan.overlayDropColorObject
      this.profileSnapshot.profileName = this.profileName;
      this.profileSnapshot.server = this.$store.state.chosenDiscord.id

      this.$root.$refs.Raidplan.createlogAction("savedRaidplan",this.profileSnapshot)
      if (this.profileName !== undefined && this.profileName.length > 0) {
        axios
          .post(this.$store.state.url + "/api/profilesRaidplan/create/", this.profileSnapshot)
          .then((res) => { })
          .catch((error) => {
            console.log("Something went wrong!");
          })
          .finally(() => {
            this.profileName = "";
            this.snackbar1 = true;
          });
      } else {

      }
    },
    getProfiles() {
      
      let server = this.$store.state.chosenDiscord.id;
      axios
        .post(this.$store.state.url + "/api/profilesRaidplan/get/", { server })
        .then((res) => {
          this.loadedProfiles = res.data.sort(function(a, b) {
   return a.profileName.localeCompare(b.profileName);
});;
        })
        .catch((error) => {
          console.log("Something went wrong!");
        })
        .finally(() => {
          if (localStorage.getItem('defaultProfile')) {
            let profileToFetch = localStorage.getItem('defaultProfile')
            this.selectedProfile = this.loadedProfiles.find((item) => item.profileName == profileToFetch)
            this.checkIfDefault()
            }
          });
    },

    cancelBtn() {
      this.dialog = false;
    },
  },
  created(){
    this.getProfiles()
  }
};
</script>
<style >
#form-profile.v-btn--absolute.v-btn--bottom,
#form-profile.v-btn--fixed.v-btn--bottom {
  right: 1px;
  margin-right: 350px;
}

#profile-card-title {
  background-color: rgb(67 67 78);
}



.settingsbuttons {
  opacity: 0.7;

}

.settingsbuttons:hover {
  opacity: 1;
}
</style>